import TicketRootCauseForm from './TicketRootCauseForm';

export default TicketRootCauseForm;
